<template>
    <b-container>
        <b-row v-if="isIntuitApp" class="d4d-decoration">
        </b-row>
        <b-row v-if="isJAApp" class="ja-decoration">
        </b-row>
        <b-col cols="12" class="mt-4">
            <b-button block variant="primary" type="button" @click="login">Log in</b-button>
        </b-col>
        <legal-warning button="Log In" />
        <legal-message/>
    </b-container>
</template>

<script>
    import LegalWarning from '../Components/LegalWarning'
    import LegalMessage from "../Components/LegalMessage"

    export default {
        name: 'SSOLogout',
        components: { LegalWarning, LegalMessage },
        methods: {
            login() {
                this.$router.push({name: 'Login'})
            }
        }
    }

</script>
<style scoped lang="stylus">
    @import "../Styles/security_styles.styl"

    .remember
        font-family arial, sans-serif
        font-size 14px
</style>